import React from 'react'
import { IconCashBanknoteFilled, IconTrendingUp } from '@tabler/icons-react'
import { Area, ComposedChart, Line, ResponsiveContainer, Tooltip } from 'recharts'
import { SalesCardWrapper } from '../../commonComponents/SalesCardWrapper'
export const SuccessRateCard = () => {

    const successRateData = [
        { value: 23 },
        { value: 58 },
        { value: 63 },
        { value: 45 },
        { value: 70 },
        { value: 38 },
    ]
    return (
        <SalesCardWrapper componentClassname='w-100 position-relative' componentStyles={{ height: "18rem", overflow: 'hidden' }}>
            <div className='d-flex justify-content-between w-100'>
                <div>
                    <span className="d-block text-dark fw-medium" style={{ fontSize: "14.5px" }}>Success Rate</span>
                    <span className={`}`} style={{ fontSize: "1.8rem", fontWeight: 400, }} >
                        85.24%
                    </span>
                </div>
                <span className={`fs-14 }`} style={{ fontWeight: 600, color: "#27ae60" }} >
                    <IconTrendingUp size={16} /> 85.24%
                </span>
            </div>
            <div
                className='position-absolute bottom-0 '
                style={{
                    width: '100%',
                    height: '10rem',
                    left: 0
                }}
            >
                <ResponsiveContainer width='100%' height='100%'>
                    <ComposedChart
                        data={successRateData}
                        margin={{ top: 20, right: 0, left: 0, bottom: 0 }}
                    >
                        <defs>
                            <linearGradient
                                id='salesGradient'
                                x1='0'
                                y1='0'
                                x2='0'
                                y2='1'
                            >
                                <stop
                                    offset='0%'
                                    stopColor='#eab30a'
                                    stopOpacity={0.25}
                                />
                                <stop
                                    offset='100%'
                                    stopColor='#fff'
                                    stopOpacity={0}
                                />
                            </linearGradient>
                        </defs>

                        <Tooltip
                            cursor={{ stroke: '#dbe4ee', strokeWidth: 1 }}
                            contentStyle={{
                                borderRadius: '10px',
                                border: '1px solid #efefef',
                                fontSize: '12px',
                                fontWeight: '600',
                            }}
                        />

                        <Area
                            type='monotone'
                            dataKey='value'
                            stroke='none'
                            fill='url(#salesGradient)'
                            fillOpacity={1}
                            tooltipType='none'
                            legendType='none'
                        />


                        <Line
                            type='monotone'
                            name='Projected'
                            dataKey='value'
                            stroke='#eab30a'
                            strokeWidth={2}
                            dot={false}
                            activeDot={{
                                r: 5,
                                strokeWidth: 0,
                                fill: '#94a3b8',
                            }}
                        />
                    </ComposedChart>
                </ResponsiveContainer>
            </div>
        </SalesCardWrapper>
    )
}
